<!--
Displays a link list of data items that can be filtered.
Usage:
  <SearchList name="foo" id="fooId" label="fooName" data="/getfoos" href="showfoo?id={fooId}&name={fooName}&exclude=foo1">
    content
  </SearchList>
  content: any valid html to appear after the search box. Add a <div class="list-group-item" /> to add a default item to the results list.
  name: the name of the data item listed e.g. building
  id: the data item field name of its id e.g. buildingId
  label: the data item field name of its display name e.g. buildingName
  data: the url where data items are retrieved from e.g. /map/buildings
  href: the url to link to when a data item is clicked. Occurrences of {id} and {label}
    will be replaced with the actual value for each data item.
  exclude: optional id of an item to exclude from the list.
@author bmk11u, ab557z
-->
<template>
  <div>
  <Spinner ref="spinner" />
    <div class="input-group m-2 w-auto">
      <div style="border-radius: 16px;border:1px solid #f7f7f7;min-height:36px;background-color:#f7f7f7;margin-left:24px;margin-right:24px;padding-left:16px;width:100%;">
        <font-awesome-icon style="color:#005C8A;" icon="search" size="sm"></font-awesome-icon>
        <input id="search" v-model="filter" type="text" style="padding-left:14px;background-color:#f7f7f7;color:#005C8A;border:0px;margin-top:4px;width:90%;" autocomplete="off" placeholder="Search for a building or room..." />
      </div>
    </div>
    <div class="list-group m-2">
      <slot></slot>
      <router-link v-for="result in results"
        :result="result"
        :key="result[id]"
        :to="parseHref(result)"
        class="buildingItem">
        {{ result[label] }}
      </router-link>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import StringUtil from '@/mixins/StringUtil.js'

export default {
  name: 'SearchList',
  props: ['name', 'id', 'label', 'data', 'href', 'exclude'],
  methods: {
    filterItem (item) {
      if (this.caseInsensitiveContains(item[this.label], this.filter)) {
        if (this.exclude == null || this.exclude !== item[this.id]) {
          this.results.push(item)
        }
      } else {
        for (var i = 0; i < this.aliases.length; i++) {
          if (this.caseInsensitiveContains(item[this.label], this.aliases[i].buildingName)) {
            if (this.exclude !== item[this.id]) {
              if (this.caseInsensitiveContains(this.aliases[i].aliasText, this.filter)) {
                this.results.push(item)
                break
              }
            }
          }
        }
      }
    },
    parseHref (result) {
      let href = this.href
      href = href.replace('{' + this.id + '}', result[this.id])
      href = href.replace('{' + this.label + '}', result[this.label])
      return href
    },
    length () {
      return this.items.length
    }
  },
  mixins: [StringUtil],
  data () {
    return {
      items: [],
      filter: '',
      results: [],
      aliases: []
    }
  },
  mounted () {
    this.$refs.spinner.spin()
    axios.get('/map/aliases', { withCredentials: false })
      .then(response => {
        this.aliases = response.data
      })
    axios.get(this.data, { withCredentials: false })
      .then(response => {
        this.items = response.data
        // console.log(this.items)
        this.results = []
        // The call to filterItem will initialise the results
        this.items.forEach(this.filterItem)
        document.getElementById('search').focus()
        this.$emit('dataLoaded', this.items.length)
      })
      .finally(() => {
        this.$refs.spinner.stop()
      })
  },
  watch: {
    filter: function () {
      this.results = []
      this.items.forEach(this.filterItem)
    }
  }
}
</script>
